/* RSF Collection (PLP) — toolbar Filter|Sort behavior + filter form submit. */

(function () {
  'use strict';

  /* ────────────────────────────────────────────────────────────────
     BELLI FILTER (temporary, da rimuovere quando unpublish):
     - URL ?_b=1 → body class belli-filter-active → CSS nasconde card non-belli
     - Click <a href="/collections/...|/products/..."> → auto-forward SOLO `_b=1`
       (preserve belli flag, NON i filter.X attivi — altrimenti "Clear filters" non funziona).
     - I filter.X tra shapes→collection sono forwardati Liquid-side (rsf-shapes-grid forward_qs).
     ──────────────────────────────────────────────────────────────── */
  const currentParams = new URLSearchParams(window.location.search);
  // Self-heal: collassa _b duplicati nell'address bar (URL già gonfio da sessioni precedenti)
  if (currentParams.getAll('_b').length > 1) {
    currentParams.delete('_b');
    currentParams.set('_b', '1');
    const qs = currentParams.toString();
    history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
  }
  if (currentParams.get('_b') === '1') {
    document.body.classList.add('belli-filter-active');
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href') || '';
      if (!/^\/(collections|products)\//.test(href)) return;
      const url = new URL(link.href, window.location.origin);
      if (!url.searchParams.has('_b')) {
        url.searchParams.set('_b', '1');
        link.href = url.pathname + url.search;
      }
    }, true);
  }

  /* ────────────────────────────────────────────────────────────────
     Sort select: change → submit page con ?sort_by= preservando filters
     Click sul select non deve aprire/chiudere il <details> toolbar.
     ──────────────────────────────────────────────────────────────── */
  document.querySelectorAll('[data-rsf-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      if (url.searchParams.has('_b')) { url.searchParams.delete('_b'); url.searchParams.set('_b', '1'); }
      window.location.href = url.toString();
    });
  });

  /* ────────────────────────────────────────────────────────────────
     Live filter preview: change checkbox → AJAX section render → swap sidebar.
     Counts e disabled options ricalcolati senza reload page; APPLY fa il reload finale.
     Pattern: Shopify Section Rendering API (?section_id=X).
     ──────────────────────────────────────────────────────────────── */
  document.querySelectorAll('.rsf-plp-filter-wrapper').forEach((filterWrapper) => {
    // Trovo section id dal data-section-id sul `<section class="rsf-plp">` parent
    const plpSection = filterWrapper.closest('[data-section-id]');
    const sectionId = plpSection ? plpSection.getAttribute('data-section-id') : null;
    if (!sectionId) return;

    let debounceTimer = null;
    const refreshSidebar = async () => {
      const form = filterWrapper.querySelector('[data-rsf-plp-filter-form]');
      if (!form) return;
      // Loading state: cursor progress + opacity overlay (visible on mobile too)
      filterWrapper.classList.add('is-loading');
      const fd = new FormData(form);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) {
        if (v !== '') params.append(k, v);
      }
      params.append('section_id', sectionId);
      const url = `${window.location.pathname}?${params.toString()}`;
      try {
        const res = await fetch(url);
        if (!res.ok) return;
        const html = await res.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newWrap = tmp.querySelector('.rsf-plp-filter-wrapper');
        if (newWrap) {
          const wasOpen = filterWrapper.hasAttribute('open');
          filterWrapper.innerHTML = newWrap.innerHTML;
          if (wasOpen) filterWrapper.setAttribute('open', '');
          // Re-apply auto-open ai group con checkbox checked (innerHTML swap rimuove .is-open class)
          autoOpenActiveGroups(filterWrapper);
        }
      } catch (e) { /* APPLY remains as fallback */ }
      finally {
        filterWrapper.classList.remove('is-loading');
      }
    };

    // Event delegation: il listener resta sul filterWrapper (parent stable, mai replaced),
    // il match e.target intercetta i NUOVI input post-swap.
    filterWrapper.addEventListener('change', (e) => {
      if (!e.target.matches('input[type="checkbox"], input[type="radio"]')) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(refreshSidebar, 150);
    });
  });

  /* ────────────────────────────────────────────────────────────────
     Filter form submit + sort sync: GET con query params.
     Event delegation su document: il form sta dentro .rsf-plp-filter-wrapper
     e viene rimpiazzato dall'innerHTML swap del live preview (refreshSidebar),
     quindi listener diretti sul form/hidden si perdono. Stesso pattern
     delegation di change/click qui sotto → sopravvive allo swap.
     ──────────────────────────────────────────────────────────────── */
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-rsf-sort-select]')) return;
    // hidden input ri-query live: post-swap il riferimento vecchio è staccato
    const hiddenSort = document.querySelector('[data-rsf-plp-filter-form] [data-rsf-hidden-sort]');
    if (hiddenSort) hiddenSort.value = e.target.value;
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-rsf-plp-filter-form]');
    if (!form) return;
    e.preventDefault();
    const formData = new FormData(form);
    const params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      if (value !== '' && value != null) {
        params.append(key, value);
      }
    }
    // Collassa _b a un solo valore (hidden input duplicati da AJAX swap → URL gonfio)
    if (params.has('_b')) { params.delete('_b'); params.set('_b', '1'); }
    const baseUrl = window.location.pathname;
    window.location.href = baseUrl + '?' + params.toString();
  });

  /* ────────────────────────────────────────────────────────────────
     Click su <select> dentro il <summary>: stopPropagation per evitare toggle
     (già nel inline onclick del select, ma double-safe per altri input)
     ──────────────────────────────────────────────────────────────── */
  document.querySelectorAll('[data-rsf-plp-details] summary input, [data-rsf-plp-details] summary select').forEach((el) => {
    el.addEventListener('click', (e) => e.stopPropagation());
  });

  /* ────────────────────────────────────────────────────────────────
     Mobile filter accordion: title cells [data-rsf-filter-toggle="X"] click →
     toggle visibility delle options [data-rsf-filter-group="X"] (mobile <1024).
     Default chiuso. Apre se filter ha active values (data-active="true").
     Event delegation pattern → sopravvive a innerHTML swap (refreshSidebar).
     ──────────────────────────────────────────────────────────────── */
  function toggleFilterGroup(scope, groupId, makeOpen) {
    const title = scope.querySelector(`[data-rsf-filter-toggle="${groupId}"]`);
    if (!title) return;
    const opts = scope.querySelectorAll(`[data-rsf-filter-group="${groupId}"]`);
    if (makeOpen) {
      title.classList.add('is-open');
      opts.forEach(o => o.classList.add('is-visible'));
    } else {
      title.classList.remove('is-open');
      opts.forEach(o => o.classList.remove('is-visible'));
    }
  }
  function autoOpenActiveGroups(scope) {
    scope.querySelectorAll('[data-rsf-filter-toggle]').forEach((title) => {
      const groupId = title.dataset.rsfFilterToggle;
      const hasActive = !!scope.querySelector(`[data-rsf-filter-group="${groupId}"] input:checked`);
      if (hasActive) toggleFilterGroup(scope, groupId, true);
    });
  }
  // Init: auto-open per group con value attivo
  document.querySelectorAll('.rsf-plp-filter-wrapper').forEach(autoOpenActiveGroups);
  // Event delegation: click su title cell apre/chiude group anche dopo innerHTML swap
  document.addEventListener('click', (e) => {
    const title = e.target.closest('[data-rsf-filter-toggle]');
    if (!title) return;
    if (window.innerWidth >= 1024) return;
    const scope = title.closest('.rsf-plp-filter-wrapper') || document;
    const groupId = title.dataset.rsfFilterToggle;
    const isOpen = title.classList.contains('is-open');
    toggleFilterGroup(scope, groupId, !isOpen);
  });

  /* ────────────────────────────────────────────────────────────────
     Infinite scroll via Section Rendering API + IntersectionObserver
     Sentinel data-next-url={pagination URL} → fetch → estrae nuovi card → append
     Quando paginate.next non esiste più, sentinel è display: none (--done)
     ──────────────────────────────────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    document.documentElement.classList.add('rsf-plp-js-active');

    const initInfiniteScroll = () => {
      const sentinel = document.querySelector('[data-rsf-plp-sentinel]');
      if (!sentinel) return;

      const grid = document.querySelector('[data-rsf-plp-grid]');
      const sectionId = sentinel.dataset.sectionId;
      let isLoading = false;
      let nextUrl = sentinel.dataset.nextUrl;

      const observer = new IntersectionObserver(async (entries) => {
        const entry = entries[0];
        if (!entry.isIntersecting || isLoading || !nextUrl) return;

        isLoading = true;
        sentinel.classList.add('rsf-plp-sentinel--loading');
        sentinel.textContent = 'Loading more...';

        try {
          // Section Rendering API: aggiungi section_id per ricevere solo la section markup
          const url = new URL(nextUrl, window.location.origin);
          url.searchParams.set('section_id', sectionId);
          // Retry con backoff: la Section Rendering API su `shopify theme dev`
          // localhost (e reti instabili in prod) ogni tanto annulla/fallisce la
          // fetch. 3 tentativi (0ms / 500ms / 1000ms) prima del fallback manuale.
          let html = null;
          let lastErr = null;
          for (let attempt = 0; attempt < 3; attempt++) {
            if (attempt > 0) {
              await new Promise((r) => setTimeout(r, attempt * 500));
            }
            try {
              const res = await fetch(url.toString());
              if (!res.ok) throw new Error('Fetch failed: ' + res.status);
              html = await res.text();
              lastErr = null;
              break;
            } catch (e) {
              lastErr = e;
            }
          }
          if (lastErr || html === null) throw lastErr || new Error('Fetch failed');

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Append nuovi card al grid (rimuovendo placeholder esistenti per mantenerli sempre alla fine)
          grid.querySelectorAll('.rsf-plp-grid__placeholder').forEach(p => p.remove());
          const newGrid = doc.querySelector('[data-rsf-plp-grid]');
          if (newGrid) {
            const newCards = Array.from(newGrid.children);
            newCards.forEach((card) => grid.appendChild(card));
          }

          // Update next URL dal sentinel della response (next page)
          const newSentinel = doc.querySelector('[data-rsf-plp-sentinel]');
          if (newSentinel && newSentinel.dataset.nextUrl) {
            nextUrl = newSentinel.dataset.nextUrl;
            sentinel.dataset.nextUrl = nextUrl;
          } else {
            // No more pages — mark done, stop observer
            nextUrl = null;
            sentinel.classList.add('rsf-plp-sentinel--done');
            observer.disconnect();
          }

          // Re-init thumbnail swipers per i nuovi card
          if (window.initRsfSwipers) window.initRsfSwipers();
          // Or fallback: dispatch custom event listened by rsf-thumbnail.js
          document.dispatchEvent(new CustomEvent('rsf:plp:appended'));

          isLoading = false;
          sentinel.classList.remove('rsf-plp-sentinel--loading');
          sentinel.textContent = 'Loading...';
        } catch (err) {
          console.error('Infinite scroll fetch failed:', err);
          sentinel.textContent = 'Failed to load — scroll to retry';
          sentinel.classList.remove('rsf-plp-sentinel--loading');
          isLoading = false;
        }
      }, {
        rootMargin: '400px 0px',
        threshold: 0
      });

      observer.observe(sentinel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initInfiniteScroll);
    } else {
      initInfiniteScroll();
    }
  }

  /* ──────────────────────────────────────────────────────────────────────
     Fill grid: quando NON ci sono altre pagine (ultima/unica), riempie con
     box vuoti (.rsf-plp-grid__placeholder) per (1) completare l'ultima riga
     e (2) coprire il viewport → niente vuoto bianco prima del footer.
     Altezza esplicita = altezza reale card (Safari-safe, no aspect-ratio).
     ────────────────────────────────────────────────────────────────────── */
  function fillPlpGrid() {
    var grid = document.querySelector('[data-rsf-plp-grid]');
    if (!grid) return;
    var sentinel = document.querySelector('[data-rsf-plp-sentinel]');
    /* Ci sono altre pagine da caricare → non riempire (lo farà a fine scroll) */
    if (sentinel && !sentinel.classList.contains('rsf-plp-sentinel--done')) return;
    grid.querySelectorAll('.rsf-plp-grid__placeholder').forEach(function (p) { p.remove(); });
    var cards = grid.querySelectorAll('.rsf-card-product');
    if (!cards.length) return;
    var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
    var cardH = cards[cards.length - 1].getBoundingClientRect().height;
    if (cardH < 50) { return; }
    /* (1) completa l'ultima riga */
    var rem = cards.length % cols;
    var need = rem === 0 ? 0 : (cols - rem);
    /* (2) righe extra finché il fondo griglia copre il viewport */
    var gap = parseFloat(getComputedStyle(grid).rowGap) || 0;
    var bottom = grid.getBoundingClientRect().bottom;
    var deficit = window.innerHeight - bottom;
    if (deficit > 0) {
      var rowsToAdd = Math.ceil(deficit / (cardH + gap));
      need += rowsToAdd * cols;
    }
    var cap = cols * 30; /* safety */
    if (need > cap) need = cap;
    for (var i = 0; i < need; i++) {
      var li = document.createElement('li');
      li.className = 'rsf-plp-grid__placeholder';
      li.setAttribute('aria-hidden', 'true');
      li.style.height = cardH + 'px';
      grid.appendChild(li);
    }
  }
  var _fpgT;
  function fillPlpGridDebounced() { clearTimeout(_fpgT); _fpgT = setTimeout(fillPlpGrid, 150); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillPlpGrid);
  } else { fillPlpGrid(); }
  window.addEventListener('load', fillPlpGrid);
  window.addEventListener('resize', fillPlpGridDebounced);
  /* Dopo append infinite-scroll (quando arriva l'ultima pagina) */
  document.addEventListener('rsf:plp:appended', fillPlpGridDebounced);
})();
